import { createReducer } from 'redux-act';
import { $all, $set, $add } from 'plow-js';
// helpers/constants
import * as GC from '../../constants';
// feature permission
import * as Actions from './actions';
//////////////////////////////////////////////////

const initialState = {
  authorities: [],
  routesAccess: [],
  permissionsList: null,
  requestPending: false,
};

const setAuthoritiesRequest = (state, payload) => $set('authorities', payload, state);

const getPermissionsRequest = (state) => $set('requestPending', true, state);

const receivedPermissionsFail = (state) => $set('requestPending', false, state);

const receivedPermissionsSuccess = (state, data) => (
  $all(
    $set('permissionsList', data),
    $set('requestPending', false),
    state,
  )
);

const addAccessToPageRequest = (state, payload) => $add('routesAccess', payload, state);

const reinitializeRoutesAccessState = (state) => $set('routesAccess', [], state);

export default createReducer({
  [GC.CLEAR_STORE]: reinitializeRoutesAccessState,
  [Actions.setAuthoritiesRequest]: setAuthoritiesRequest,
  [Actions.getPermissionsRequest]: getPermissionsRequest,
  [Actions.addAccessToPageRequest]: addAccessToPageRequest,
  [Actions.receivedPermissionsFail]: receivedPermissionsFail,
  [Actions.receivedPermissionsSuccess]: receivedPermissionsSuccess,
}, initialState);

